import { render, staticRenderFns } from "./Changpas.vue?vue&type=template&id=be5f559e&scoped=true&"
import script from "./Changpas.vue?vue&type=script&lang=js&"
export * from "./Changpas.vue?vue&type=script&lang=js&"
import style0 from "./Changpas.vue?vue&type=style&index=0&id=be5f559e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5f559e",
  null
  
)

export default component.exports